export default __webpack_public_path__ + "static/Metal_Door-5e30fad04fa069bb14e5358c33ed678e.png";